import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    error: null,
    eventVisible: false,
    totalRecords: 0,
    contacts: [],
    loadingContacts: false,
});

const actions = {
    async eventReadAll({ commit }, query) {
        try {
            commit('eventReadAllBegin');
            const response = await DataService.get(`/events?${new URLSearchParams(query).toString()}`);
            commit('eventReadAllSuccess', response.data.data.list);
        } catch (err) {
            commit('eventReadAllErr', err);
        }
    },

    async eventAdd({ commit }, data) {
            commit('eventAddBegin');
            await DataService.post('/events', data).then(response => {
                commit('eventAddSuccess', response.data.data);

                notification.success({
                    message: response.data.message
                });
            }).catch(err => {
                commit('eventAddErr', err);
            });
    },

    async eventUpdate({ commit }, data) {
        commit('eventUpdateBegin');
        await DataService.put(`/events/${data.id}`, data).then(response => {
            commit('eventUpdateSuccess', response.data.data);

            notification.success({
                message: response.data.message
            });
        }).catch(err => {
            commit('eventUpdateErr', err);
        });
    },

    async eventDelete({ commit }, id) {
        commit('eventDeleteBegin');
        await DataService.delete(`/events/${id}`).then(response => {
            commit('eventDeleteSuccess', id);

            notification.success({
                message: response.data.message
            });
        }).catch(err => {
            commit('eventDeleteErr', err);
        });
    },

    async eventVisible({ commit }, data) {
        try {
            commit('eventVisibleBegin');
            commit('eventVisibleSuccess', data);
        } catch (err) {
            commit('eventVisibleErr', err);
        }
    },

    async eventContactsReadAll({ commit }, query) {
        commit('eventContactsReadAllBegin');
        await DataService.get(`/contacts?${new URLSearchParams(query).toString()}`).then(response => {
            commit('eventContactsReadAllSuccess', response.data.data.list);
        }).catch(err => {
            commit('eventContactsReadAllErr', err);
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};